@if (pageSize$(); as currentPageSize) {
  <section
    id="plp-srlp-top-pagination"
    class="top-pagination_container hmf-display-flex hmf-flex-wrap hmf-justify-content-flex-end hmf-text-align-right hmf-mr-xs hmf-mr-lg-s hmf-py-lg-xxs hmf-body-m"
  >
    @if (!isMobile() && pageSizeOptions().length > 0) {
      <div class="top-pagination hmf-display-none hmf-display-lg-block">
        <span class="hmf-mr-s">View:</span>
        @for (pageSize of pageSizeOptions(); track pageSize) {
          <button
            class="top-pagination_number hmf-mr-s"
            [class]="pageSize === currentPageSize ? 'selected hmf-body-bold-m' : ''"
            (click)="pageSizeClickEvent(pageSize, currentPageSize)"
          >
            {{ pageSize }}
          </button>
        }
      </div>
    }
    <div class="top-pagination-product-number">
      @if (pageSizeOptions().length > 0) {
        <span class="hmf-mr-xs">|</span>
      }
      {{ totalCount$() | usWholeNumber }}
      {{ totalCount$() === 1 ? 'Product' : 'Products'}}
    </div>
  </section>
}
